export const getUsers = async () => {
  const response = await fetch(`/api/users`);
  if (!response.ok) {
    throw new Error('Failed to fetch users');
  }
  return response.json();
};

export const createUser = async (name: string) => {
    const response = await fetch(`/api/edit/users`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ name }),
  });

  if (!response.ok) {
    throw new Error('Failed to create user');
  }

  return response.json();
};

export const addUserToSeason = async (userId: number, season: number) => {
  const response = await fetch(`/api/edit/seasons/users`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ user_id: userId, season }),
  });

  if (!response.ok) {
    throw new Error('Failed to add user to season');
  }

  return response.json();
};

export const createSeason = async (year: number) => {
  const response = await fetch(`/api/edit/seasons`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ year }),
  });

  if (!response.ok) {
    const body = await response.json().catch(() => null);
    throw new Error(body?.message || 'Failed to create season');
  }

  return response.json();
};

export const removeUserFromSeason = async (userId: number, season: number) => {
    const response = await fetch(`/api/edit/seasons/users`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ user_id: userId, season }),
  });

  if (!response.ok) {
    throw new Error('Failed to remove user from season');
  }

  return response.json();
};

interface Prediction {
  team_id: number;
  predicted_rank: number;
}


export const getCurrentStatus = async (season?: number) => {
  const url = season ? `/api/predictions/current-status?season=${season}` : `/api/predictions/current-status`;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error('Failed to fetch current status');
  }
  return response.json();
};

export const getSeasons = async (): Promise<number[]> => {
  const response = await fetch(`/api/predictions/seasons`);
  if (!response.ok) {
    throw new Error('Failed to fetch seasons');
  }
  return response.json();
};

export const savePredictions = async (userId: number, season: number, predictions: Prediction[]) => {
    const response = await fetch(`/api/edit/predictions`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ user_id: userId, season, predictions }),
  });

  if (!response.ok) {
    throw new Error('Failed to save predictions');
  }

  return response.json();
};
